import type { LANG } from '@eshop/type'
import type Rental from '@eshop/type/rental'

import i18n from './i18n'
import css from './index.module.css'

import { ProductHelper } from '#/global/helper/Product/ProductHelper'

interface Props {
    lang: LANG
    product: Rental.Product<'detail'>
}

export const PriceRental = ({ lang, product }: Props) => {
    const t = i18n[lang]
    const price = ProductHelper.formatPrice(product.detail.priceVatOrigin, product.detail.currencyCode).split(',')

    return (
        <div className={`r-product-price-rental ${css.wrap}`}>
            <div className={css.price}>
                <span className={css.priceBig}>{price[0]}</span>
                <span>
                    ,
                    {price[1]}
                </span>
            </div>
            <div className={css.info}>{t.pricePerUnit(product.detail.unitPrice)}</div>
        </div>
    )
}
